import assignment from 'assignment';
import deepFreeze from 'deep-freeze';

import {
  SET_RADIUS_OPEN,
  SHOW_AUTOCOMPLETE_KEYWORD,
  SHOW_AUTOCOMPLETE_WORKPLACE
} from 'src/redux/constant/actionsType';


const initialViewState = {
  autocomplete: {
    workplace: {
      show: false
    },
    keyword: {
      show: false
    }
  }
};


const showAutocompleteKeyword = (state, action) => {
  deepFreeze(state);

  const newValue = {
    autocomplete: {
      keyword: {
        show: action.state
      }
    }
  };
  return assignment({}, state, newValue);
};

const showAutocompleteWorkplace = (state, action) => {
  deepFreeze(state);

  const newValue = {
    autocomplete: {
      workplace: {
        show: action.state
      }
    }
  };
  return assignment({}, state, newValue);
};

const setRadiusOpen = (state, action) => {
  deepFreeze(state);
  return assignment({}, state, { radiusOpen: action.state });
};

export default (state = initialViewState, action = {}) => {
  const payload = {
    [SHOW_AUTOCOMPLETE_WORKPLACE]: showAutocompleteWorkplace,
    [SHOW_AUTOCOMPLETE_KEYWORD]: showAutocompleteKeyword,
    [SET_RADIUS_OPEN]: setRadiusOpen
  };
  return (payload[action.type] || (() => state))(state, action);
};
